import React from 'react';
import { Alert, Button } from '@mui/material';
import { suggestCaseFix } from '../../utils/textCase';

/**
 * Aviso bajo un campo de nombre cuando parece tener un error de mayúsculas ("TIenda UNo").
 * No bloquea el guardado: el usuario puede corregir con un clic o dejarlo como está.
 */
const CaseTypoHint = ({ value, onFix }) => {
  const suggestion = suggestCaseFix(value);
  if (!suggestion) return null;
  return (
    <Alert
      severity="warning"
      sx={{ mt: 1, py: 0, fontSize: '0.85rem', alignItems: 'center' }}
      action={onFix ? <Button color="inherit" size="small" onClick={() => onFix(suggestion)}>Corregir</Button> : null}
    >
      ¿Quisiste decir «{suggestion}»?
    </Alert>
  );
};

export default CaseTypoHint;
